import { Box, Button, Typography } from '@mui/material';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import { useTranslation } from 'react-i18next';

import { useOpenMembership } from '@/hooks/useOpenMembership';
import { BORDER_RADIUS, semanticColors } from '@/theme/tokens';
import { SettingsSection, useSettingsSurface } from './SettingsSection';

/** Entry to the membership screen. The dialog closes itself first via `onBeforeOpen`. */
export default function MembershipSettingsSection({ onBeforeOpen }: { onBeforeOpen?: () => void }) {
  const { t } = useTranslation('settings');
  const surface = useSettingsSurface();
  const openMembership = useOpenMembership();

  return (
    <SettingsSection labelledBy={surface === 'page' ? 'settings-membership-title' : undefined}>
      <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1, mb: 2 }}>
        {surface === 'page' && (
          <FavoriteBorderIcon sx={{ color: semanticColors.textPrimary, mt: 0.2, fontSize: 20 }} />
        )}
        <Box>
          {surface === 'page' && (
            <Typography
              id="settings-membership-title"
              component="h2"
              sx={{ fontWeight: 700, fontSize: '15px', lineHeight: 1.3 }}
            >
              {t('sections.membership')}
            </Typography>
          )}
          <Typography
            sx={{
              fontSize: surface === 'dialog' ? '14px' : '13px',
              color: semanticColors.textTertiary,
              mt: surface === 'page' ? 0.5 : 0,
            }}
          >
            {t('membershipDesc')}
          </Typography>
        </Box>
      </Box>
      <Button
        variant="outlined"
        onClick={() => {
          onBeforeOpen?.();
          openMembership('settings');
        }}
        sx={{
          textTransform: 'none',
          borderRadius: BORDER_RADIUS,
          px: '16px',
          height: '44px',
          fontWeight: 600,
          color: semanticColors.textPrimary,
          borderColor: semanticColors.textPrimary,
        }}
      >
        {t('becomeMember')}
      </Button>
    </SettingsSection>
  );
}
